import { n as trapFocus, t as removeTrapFocus } from "@theme/theme";
//#region theme/frontend/islands/product-lightbox.js
var ProductLightbox = class extends HTMLElement {
	connectedCallback() {
		if (!window.matchMedia("(min-width: 768px)").matches) return;
		const script = this.querySelector("script[type=\"application/json\"]");
		if (!script) return;
		this.media = JSON.parse(script.textContent);
		if (!this.media.length) return;
		this.currentIndex = 0;
		this.overlay = this.querySelector("[data-lightbox]");
		this.mainImg = this.overlay.querySelector("[data-lightbox-img]");
		this.prevBtn = this.overlay.querySelector("[data-lightbox-prev]");
		this.nextBtn = this.overlay.querySelector("[data-lightbox-next]");
		this.prevImg = this.overlay.querySelector("[data-prev-img]");
		this.nextImg = this.overlay.querySelector("[data-next-img]");
		this.label = this.overlay.querySelector("[data-lightbox-label]");
		this.closeBtn = this.overlay.querySelector("[data-lightbox-close-btn]");
		this.cursorBadge = this.overlay.querySelector("[data-cursor-close]");
		this._triggerEl = null;
		document.body.appendChild(this.overlay);
		const gallery = this.closest("[data-product-gallery]");
		if (gallery) gallery.querySelectorAll("[data-expand-trigger]").forEach((trigger, i) => {
			trigger.addEventListener("click", () => this.open(i));
		});
		this.closeBtn.addEventListener("click", (e) => {
			e.stopPropagation();
			this.close();
		});
		this.overlay.addEventListener("click", (e) => {
			if (!e.target.closest("[data-lightbox-prev]") && !e.target.closest("[data-lightbox-next]") && !e.target.closest("[data-lightbox-close-btn]")) this.close();
		});
		if (this.prevBtn) this.prevBtn.addEventListener("click", (e) => {
			e.stopPropagation();
			this.prev();
		});
		if (this.nextBtn) this.nextBtn.addEventListener("click", (e) => {
			e.stopPropagation();
			this.next();
		});
		this._onKeydown = (e) => {
			if (e.key === "Escape") this.close();
			else if (e.key === "ArrowLeft") this.prev();
			else if (e.key === "ArrowRight") this.next();
		};
		[
			this.prevBtn,
			this.nextBtn,
			this.closeBtn
		].filter(Boolean).forEach((btn) => {
			btn.addEventListener("mouseenter", () => {
				if (this.cursorBadge) this.cursorBadge.style.visibility = "hidden";
			});
			btn.addEventListener("mouseleave", () => {
				if (this.cursorBadge) this.cursorBadge.style.visibility = "";
			});
		});
	}
	open(index) {
		this._triggerEl = document.activeElement;
		this.currentIndex = index;
		this._render();
		this.overlay.classList.remove("hidden");
		this.overlay.classList.add("flex");
		document.body.classList.add("overflow-hidden");
		document.addEventListener("keydown", this._onKeydown);
		this._preload();
		if (this.cursorBadge && this.cursorBadge._arrowSize === "0px") {
			const arrow = this.cursorBadge.querySelector("[data-arrow]");
			if (arrow) {
				arrow.style.width = "";
				arrow.style.padding = "0.25rem";
				this.cursorBadge._arrowSize = arrow.offsetHeight + "px";
				arrow.style.width = "0";
				arrow.style.padding = "0";
			}
		}
		requestAnimationFrame(() => {
			this.overlay.classList.remove("opacity-0");
			this.overlay.classList.add("opacity-100");
			setTimeout(() => {
				this.mainImg.classList.remove("opacity-0");
				this.mainImg.classList.add("opacity-100");
			}, 100);
			trapFocus(this.overlay, this.closeBtn);
		});
	}
	close() {
		this.mainImg.classList.remove("opacity-100");
		this.mainImg.classList.add("opacity-0");
		this.overlay.classList.remove("opacity-100");
		this.overlay.classList.add("opacity-0");
		this.overlay.addEventListener("transitionend", () => {
			this.overlay.classList.remove("flex");
			this.overlay.classList.add("hidden");
		}, { once: true });
		document.body.classList.remove("overflow-hidden");
		document.removeEventListener("keydown", this._onKeydown);
		removeTrapFocus(this._triggerEl);
	}
	prev() {
		if (this.media.length <= 1) return;
		this.currentIndex = (this.currentIndex - 1 + this.media.length) % this.media.length;
		this._render();
	}
	next() {
		if (this.media.length <= 1) return;
		this.currentIndex = (this.currentIndex + 1) % this.media.length;
		this._render();
	}
	_render() {
		const current = this.media[this.currentIndex];
		this.mainImg.src = current.url;
		this.mainImg.alt = current.alt;
		if (this.media.length > 1) {
			const prevIdx = (this.currentIndex - 1 + this.media.length) % this.media.length;
			const nextIdx = (this.currentIndex + 1) % this.media.length;
			this.prevImg.src = this.media[prevIdx].thumb;
			this.prevImg.alt = this.media[prevIdx].alt;
			this.nextImg.src = this.media[nextIdx].thumb;
			this.nextImg.alt = this.media[nextIdx].alt;
		}
		const num = String(this.currentIndex + 1).padStart(2, "0");
		this.label.textContent = `FIGURE ${num}`;
	}
	_preload() {
		if (this._preloaded) return;
		this._preloaded = true;
		for (const item of this.media) {
			const link = document.createElement("link");
			link.rel = "prefetch";
			link.as = "image";
			link.href = item.url;
			document.head.appendChild(link);
		}
	}
	disconnectedCallback() {
		this.overlay?.remove();
	}
};
customElements.define("product-lightbox", ProductLightbox);
//#endregion
